import DataTile from "./DataTile";
import { fetchVectorsAction} from "../../../actions";
import React from "react";
import {
    bbIsVectorRisk,
    filterObject
} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import BBIconVector from "../../../assets/bbCustomIcons/BBIconVector";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const valueFunction = (stateData) => stateData
        ? stateData[customerIdToUse]
            ? (stateData[customerIdToUse].vectors && stateData[customerIdToUse].campaigns)
                ? Object.keys(filterObject(stateData[customerIdToUse].vectors, (_, vector) => bbIsVectorRisk(vector, 3))).length
                : null
            : null
        : null;

    // const translateValueToRisk = (value) => {
    //     if (typeof value !== "number") {
    //         return null
    //     } else if (value <= 0) {
    //         return 0
    //     } else if (value <= 0) {
    //         return 1
    //     } else if (value <= 1) {
    //         return 2
    //     } else if (value <= 4) {
    //         return 3
    //     } else {
    //         return 4
    //     }
    // }

    // const colorFunction = (stateData) => {
    //     const num = valueFunction(stateData);
    //     return bbTranslateRiskToColor(translateValueToRisk(num));
    // }

    // const riskRibbon = (stateData) => {
    //     const num = translateValueToRisk(valueFunction(stateData));
    //     return num
    //         ? <RiskRibbon ratingBy5={num} />
    //         : null;
    // }


    return (
        <DataTile
            // colorBgFunction={colorFunction}
            subTitle="Vectors Under Attack"
            tipText={`Number Vectors currently being attacked by BreachBits.`}
            icon={<BBIconVector style={{fontSize: "70px"}}/>}
            stateName="customer"
            stateElement="customers"
            useDeepDataStore
            // dontFetch
            deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].vectors : null : null}
            stateLoaderName="loadingVectors"
            stateLoaderError="loadingVectorsError"
            stateFetchAction={fetchVectorsAction({
                customerId: customerIdToUse
            })}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            // ribbonFunction={riskRibbon}
            // showKRIRibbon
            requiresModule={"perimeter"}
        />
    )

}

export default Tile;